import { AppProviders } from "@/app/providers";

export function App() {
  return <AppProviders />;
}
